import React from 'react';
import FormRange from 'react-bootstrap/FormRange';

export interface RangeControlProps {
  name: string
  value: number
  min: number | string
  max: number | string
  step?: number | string

  setValue(value: number): void
}

export default function RangeControl({ name, setValue, value, min, max, step }: RangeControlProps) {
  return <>
    <span className="px-2">{name}</span>
    <FormRange min={min} max={max} step={step || 0.01} value={value}
               onChange={event => setValue(Number(event.target.value))}
    />
    <span className="px-2">{(value * 100).toFixed(0)}%</span>
    <span className="px-2">({value.toFixed(2)})</span>
  </>
}
